import { getCategoriesByProducts } from "@/js/repository/CategoryRepository";

export async function getServerSideProps(context: any) {
  const { locale } = context;
  console.log(locale);
  const statusCode = context.res.statusCode;
  const categories = await getCategoriesByProducts(locale); //Header에 사용할 카테고리 목록
  return {
    props: {
      statusCode,
      categories,
      locale,
    },
  }
}

export default function CustomError({ statusCode }: { statusCode: number }) {
  return (
    <>
      <div className="flex items-center justify-center h-[calc(100vh-164px-96px)]">
        <header>
          <h1 className="text-3xl font-bold">{statusCode} - { statusCode === 404 ? "Page Not Found." : "Something went wrong."}</h1>
        </header>
      </div>
    </>
  )
}